// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"21a6768b40220990","4745":"9876b178d7a96a96"}[chunkId] + ".css";
};